import { addCarrierAccountWorkflow } from './addCarrierAccountWorkflow';
import { editCarrierAccountWorkflow } from './editCarrierAccountWorkflow';
import { addShipiumCredentials } from './addShipiumCredentials';
import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';

export const workflows: WorkflowOptions[] = [
  addCarrierAccountWorkflow,
  editCarrierAccountWorkflow,
  addShipiumCredentials,
  ...Object.values(generateAssetStatusWorkflow('carrierAccount')),
];

export default workflows;
